<template>
	<div>
		<Table :columns="columns1" :data="data" size="small"></Table>
	</div>
</template>

<script>
	// 限定场站列表	StationList
	// 限定场站列表	StationArray
	// 限定运营商列表	OperatorList
	// 限定运营商列表	OpeartorArray
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		props: {
			row: Array
		},
		data() {
			return {
				columns1: [{
						title: this.$tt('订单编号'),
						key: 'OrderNo',
						width: 260
					}, {
						title: this.$tt('订单时间'),
						key: 'OrderTime',
						width: 180
					}, {
						title: this.$tt('订单金额(元)'),
						key: 'OrderAmount',
						width: 120
					}, {
						title: this.$tt('订单电费(元)'),
						key: 'OrderAmountElec',
						width: 120,
					}, {
						title: this.$tt('订单服务费(元)'),
						key: 'OrderAmountService',
						width: 120,
					}
				],
				data:this.row,
			}
		},
		computed:{
			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
		}
	}
</script>

<style>
	.tableExtend td.ivu-table-expanded-cell {
		padding: 0px 0px !important;
	}

	.ivu-table-expanded-cell th {
		background-color: #d4d4d5;
	}

	.ivu-table-expanded-cell td {
		background-color: #ebebeb;
	}
</style>
